import { render } from "./Forbidden.vue?vue&type=template&id=be00057a&scoped=true&ts=true"
import script from "./Forbidden.vue?vue&type=script&lang=ts"
export * from "./Forbidden.vue?vue&type=script&lang=ts"

import "./Forbidden.vue?vue&type=style&index=0&id=be00057a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-be00057a"]])

export default __exports__